<div id="notfound">
    <div class="notfound">
        <div class="notfound-404">
            <h1>{{errorCode}}</h1>
        </div>
        <h2>{{errorTitle}}</h2>
        <p>{{errorDescription}}
            <a href="javascript:;" [routerLink]="errorLink">{{errorLinkTitle}}</a></p>
    </div>
</div>